import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { Divider, Label, SectionHeader, Text } from '../../CommonStyledComponents/CommonStyledComponents';

interface ViewDefectApprovalReleaseRequiredProps {
  approvalReleaseName: string;
  approvalReleaseRequired: boolean;
}

const Wrapper = styled.div`
  margin: 20px 0;
`;

const ViewDefectApprovalReleaseRequired: React.FC<ViewDefectApprovalReleaseRequiredProps> = ({
  approvalReleaseName,
  approvalReleaseRequired,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Divider />

      <SectionHeader data-testid="ViewDefectApprovalReleaseRequired-Header">
        {approvalReleaseName}
      </SectionHeader>

      <Wrapper>
        <Label>{
          formatMessage(
            { id: 'text.isAnApprovalReleaseRequiredShort' }, { field: approvalReleaseName }
          )
        }</Label>
        <Text>{approvalReleaseRequired ? 'YES' : 'NO'}</Text>
      </Wrapper>
    </div>
  );
};

export default ViewDefectApprovalReleaseRequired;
